export default __webpack_public_path__ + "static/media/regulatory--night-speed-limit-15--g1.74d7f0eb.png";